<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { InputNumber } from 'ant-design-vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { getRequiredRule } from '@/constant/form'
const [name] = createNamespace('RewardNoResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    },
    prefix: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props) {
    const genFormItemName = (key: string) => [...props.prefix, key]
    const data = toRef(props, 'dataSync', {})
    return () => (
      <div class='ant-row-form-item'>
        拆迁奖励及搬迁补助按住房面积（不含生产经营性用房）补偿款的
        <FormItem name={genFormItemName('chaiQianBuYuAnZhi')} rules={getRequiredRule('拆迁不予安置的房屋拆迁奖励标准')}>
          <InputNumber
            v-model:value={data.value.chaiQianBuYuAnZhi}
            style='width: 150px'
            placeholder='请输入'
            min={0}
            precision={2}
            step={0.01}
            addonAfter='%'
          />
        </FormItem>
        计算。
      </div>
    )
  }
})
</script>
